import React from 'react';

export default class CampaignMenu extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        const posting = this.props.selectedCampaignType === 'posting';
        const play = this.props.selectedCampaignType === 'play';
        return (
            <div className="row campaign-menu">
                <div className="col-xs-12">
                    {this.props.playData &&
                        <button className={(play ? 'selected' : '') + ' btn btn-lg btn-play'} onClick={() => this.props.onSelectCampaignType('play')}>{this.props.customHeader ? this.props.customHeader : 'Proof of Play'}</button>
                    }
                    {this.props.postingData &&
                        <button className={(posting ? 'selected' : '') + ' btn btn-lg btn-posting'} onClick={() => this.props.onSelectCampaignType('posting')}>{this.props.customHeader ? this.props.customHeader : 'Proof of Posting'}</button>
                    }
                </div>
            </div>
        );
    }
}